var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIrritability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3165_12203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 6.375L19.875 0L22.0625 13.3125L32 16.2903L23.125 18.6875L28.8125 27.625L17.8125 23L16.3125 27.125L12.5 23.6875L5.1875 32L6.1875 20.875L1.375 21.875L7.625 15.4375L0 2.8125L10.5625 8.8125L11.25 4.5L14 8L15.3125 6.375Z",
    fill: "#429E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 11.25L11.4375 15.1875L9.0625 17.75L10.8125 17.8125L9.25 22.6875L13.5625 19.1875L15.5625 21.9375L16.3125 17.5625L20.5 19.6875L18.8125 17.0625L21.5625 15.9375L18 15.1875L18.3125 7.1875L15.25 13.25L13.3125 11.0625L13.5 13.9375L8.6875 11.25Z",
    fill: "#66AB8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3165_12203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrritability);
export default __webpack_public_path__ + "static/media/irritability.39462f23a5dd5b7e5b2a6dccbcdc37dc.svg";
export { ForwardRef as ReactComponent };